import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getUsersById } from 'auth/store/users/selectors';
import Flex from 'base/components/Flex';
import { CloseIcon, ArrowForwardIcon } from 'base/components/Icon';
import CustomScroll from 'base/components/ScrollBar';
import { navigateToDocument } from 'documents/store/documents/actions';
import Loader from 'base/components/Loader';
import FileExplorerTeaser from 'dashboard/containers/FileExplorerTeaser/FileExplorerTeaser';
import FileExplorerTeaserSkeleton from 'dashboard/containers/FileExplorerTeaser/FileExplorerTeaserSkeleton';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { navigateToFolder } from 'documents';
import { getFavorites, getFavoritesIsLoading } from '../../store/favorites/selectors';
import { fetchFavorites, removeFavorite } from '../../store/favorites/actions';

const WidgetWrapper = styled(Flex)`
  position: relative;
  flex-direction: column;
  height: 100%;
`;

export default function Favorites({ dashboardId }) {
  const dispatch = useAppDispatch();
  const favorites = useAppSelector(getFavorites);
  const users = useAppSelector(getUsersById);
  const isLoading = useAppSelector(getFavoritesIsLoading);

  // console.log('### favorites', favorites);

  useEffect(() => {
    dispatch(fetchFavorites());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchFavorites());
  }, [dashboardId, dispatch]);

  const handleClick = useCallback(
    entity => {
      if (document.entityType === 'document') {
        dispatch(navigateToDocument(entity));
      } else {
        dispatch(navigateToFolder(entity));
      }
    },
    [dispatch],
  );

  const handleRemove = useCallback(
    entity => {
      dispatch(removeFavorite(entity.entityType, entity.id));
    },
    [dispatch],
  );

  const actions = [
    {
      icon: ArrowForwardIcon,
      onClick: handleClick,
      key: 'primary',
    },
    {
      icon: CloseIcon,
      onClick: handleRemove,
      key: 'remove',
    },
  ];

  return (
    <WidgetWrapper>
      <CustomScroll>
        <Loader isLoading={isLoading} fallback={<FileExplorerTeaserSkeleton />}>
          {favorites &&
            favorites.map(document => (
              <FileExplorerTeaser key={document.id} entity={document} users={users} actions={actions} />
            ))}
        </Loader>
      </CustomScroll>
    </WidgetWrapper>
  );
}
Favorites.propTypes = {
  dashboardId: PropTypes.number,
};
Favorites.defaultProps = {
  dashboardId: null,
};
